import { capitalizeFirstLetter } from "~/helpers/jsutil";
import { useSettingsStore } from "~/stores/settings";

/**
 * Replaces all keys of given mapObj with matching values of mapObj
 *
 * @param {string} str
 * @param {Object} mapObj  object with key value pairs to replace
 * @returns
 */
export function replaceAll(str, mapObj) {
  const re = new RegExp(Object.keys(mapObj).join("|"), "g");
  if (Array.isArray(str)) {
    str = str.map((x) =>
      typeof x === "string" ? x.replace(re, (matched) => mapObj[matched]) : x
    );
    return str;
  }

  if (!str || typeof str === "object") {
    return str;
  }

  return str.replace(re, (matched) => mapObj[matched]);
}

function setNameValuePairToMap(value, name, replaceMap, locale) {
  if (typeof value === "string") {
    replaceMap[`<${name}>`] = value;
  } else if (typeof value === "object" && !Array.isArray(value)) {
    // Check if it's a locale map (has locale keys like 'hu-HU', 'en-US', etc.)
    const localeKeys = Object.keys(value);
    const isLocaleMap =
      localeKeys.length > 0 &&
      localeKeys.every((key) =>
        [
          "hu-HU",
          "en-US",
          "cs-CZ",
          "de-DE",
          "pl-PL",
          "sk-SK",
          "ro-RO",
          "hr-HR",
          "de-AT",
        ].includes(key)
      );

    if (isLocaleMap && locale && value[locale]) {
      // Use locale-specific value
      replaceMap[`<${name}>`] = value[locale];
    } else if (isLocaleMap && value["hu-HU"]) {
      // Fallback to Hungarian if locale not found
      replaceMap[`<${name}>`] = value["hu-HU"];
    } else {
      // Regular nested object, recurse
      for (const key in value) {
        setNameValuePairToMap(
          value[key],
          name + capitalizeFirstLetter(key),
          replaceMap,
          locale
        );
      }
    }
  } else if (Array.isArray(value)) {
    // Arrays are not processed (e.g., features array)
  } else {
    throw new TypeError("Unsupported type");
  }
}

function buildReplaceMap(branding, locale, baseName = "branding") {
  if (!branding) {
    return {};
  }
  const replaceMap = {};
  for (const key in branding) {
    if (key === "default") {
      continue;
    }
    setNameValuePairToMap(
      branding[key],
      baseName + capitalizeFirstLetter(key),
      replaceMap,
      locale
    );
  }
  return replaceMap;
}

export default function (ctx, _inject) {
  const settingsStore = useSettingsStore(ctx.$pinia);
  const isSupportPhoneVisible = settingsStore.supportPhoneVisible;

  const { email, phone, emailLink, phoneLink } = ctx.$helpers.support;
  /**
   * Work around for postTranslation not working in nuxt.config.js for some reason only string is accepted, that then throws not a function eror
   *
   * @param {*} str
   * @param {*} key
   * @returns
   */
  ctx.i18n.postTranslation = function (str, _key) {
    const currentLocale = ctx.i18n.locale; // Get current locale
    return replaceAll(str, {
      "<supportInfo>": isSupportPhoneVisible ? `${email} / ${phone}` : email,
      "<supportInfoLink>": isSupportPhoneVisible
        ? `<a href='${emailLink}'>${email}</a> / <a href='${phoneLink}'>${phone}</a>`
        : `<a href='${emailLink}'>${email}</a>`,
      "<supportEmail>": ctx.$helpers.support.email,
      "<supportPhone>": ctx.$helpers.support.phone,
      "<supportEmailLink>": ctx.$helpers.support.emailLink,
      "<supportPhoneLink>": ctx.$helpers.support.phoneLink,
      ...buildReplaceMap(ctx.$brand, currentLocale),
    });
  };
}
